import { OrderStatusEnum } from 'modules/order/graphql/queries/useGetOrder';

export const isOrderReadonlyByStatus = (status: OrderStatusEnum) => !(status === OrderStatusEnum.CREATED || status === OrderStatusEnum.RETURNED);
